import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { isObject, isString, logErrorAndRunFail } from '../../utils';

export interface ReportLogOption {
  level: string;
  log: Object | string;
}

// 日志上报
export function reportLog(option: ReportLogOption) {
  if (!option.log || !(isObject(option.log) || isString(option.log))) {
    return logErrorAndRunFail(
      APINames.Native.REPORT_LOG,
      option,
      'parameter error:  parameter.log should be Object or String instead of Undefined.'
    );
  }
  const validLevel = ['debug', 'info', 'error'];
  if (option.level && validLevel.indexOf(option.level) === -1) {
    return logErrorAndRunFail(
      APINames.Native.REPORT_LOG,
      option,
      `parameter error:  invalid level ${option.level}`
    );
  }
  if (isObject(option.log)) {
    option.log = JSON.stringify(option.log);
  }
  const fixedOption = Object.assign(
    {
      level: 'info'
    },
    option
  );
  return MacleJSBridge.notifyNative(APINames.Native.REPORT_LOG, fixedOption);
}
